/* eslint-disable no-restricted-imports */
import { type ReactElement } from 'react';
import { FormControl, Select as SelectMUI, styled } from '@mui/material';

import { ExpandMore } from '@mui/icons-material';

import { Typography } from '../Typography';

import { Item } from './elements/Item';

export type SelectProps = React.ComponentProps<typeof SelectMUI>;

export type SelectElement = React.FC<SelectProps> & {
  Item: typeof Item;
};

const StyledLabel = styled(Typography)(({ theme }) => ({
  color: 'var(--text-text-secondary-color)',
  fontSize: 12,
  lineHeight: 1.5,
  marginBottom: theme.spacing(1),
}));

const StyledFormControl = styled(FormControl)({
  width: '100%',
});

export const Select: SelectElement = ({ children, ...props }): ReactElement => {
  return (
    <StyledFormControl>
      {props.label ? <StyledLabel>{props.label}</StyledLabel> : null}
      <SelectMUI IconComponent={ExpandMore} {...props}>
        {children}
      </SelectMUI>
    </StyledFormControl>
  );
};

Select.Item = Item;
